import callApi from "Common/utils/apiCaller";
import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import Drawer from "../Drawer";
import descriptionStyle from "../../../constants/descriptionStyle.json";
import ReactSelect from "../ReactSelect/ReactSelect";
import ToggleSwitch from "../ToggleSwitch/ToggleSwitch";
import Button from "../ButtonComponent/Button";
import NumberScrollSegmentCard from "../NumberScrollSegmentCard";
import CustomInput from "../InputFields/CustomInput";
import ImageData from "../customImage/ImageSegment";
import ImageView from "../ImageView/ImageView";
import { X } from "lucide-react";
import { showNotification } from "Common/utils/Notification";

const NumberScrollSegment = ({
  pageId,
  data,
  handleDelete,
  loader,
  setLoader,
  isEditable,
  versionData,
  segmentType,
  segmentId,
  toggleVisiblity,
}) => {
  const number = data?.scroll_numbers ? data?.scroll_numbers : [];
  const [buttons, setButtons] = useState(number);
  const [styleType, setStyleType] = useState("");
  const [saticStyle, setStaticStyle] = useState<any>();
  const [headerText, setHeaderText] = useState<any>(data?.segment_header_text);
  const [isLoading, setIsLoading] = useState<any>(false);
  const [imageData, setImageData] = useState<any>("");
  const [showImage, setShowImage] = useState<any>(false);
  const toggleImage = () => setShowImage(!showImage);
  const [imageUrl, setImageUrl] = useState(
    data?.value_image_url ? data?.value_image_url : ""
  );
  const [imageId, setImageId] = useState("");
  const [mobileBackground, setMobileBackground] = useState<any>(
    data?.mobile_background_image
  );
  const [mobileBackgroundId, setMobileBackgroundId] = useState<any>("");
  const [indexBack, setIndexBack] = useState("");

  useEffect(() => {
    if (imageData && imageData?.media_url) {
      if (imageData?.media_type === "image") {
        if (indexBack === undefined) {
          setImageUrl(imageData.media_url);
          setImageId(imageData._id);
          setErrors((prev) => ({ ...prev, ["background_image"]: "" }));
        } else if (indexBack === "background") {
          setMobileBackground(imageData.media_url);
          setMobileBackgroundId(imageData._id);
          setErrors((prev) => ({ ...prev, ["mobile_background_image"]: "" }));
        }
      } else {
        showNotification("Media type should be image", "error");
      }
    }
  }, [imageData, indexBack]);

  const [errors, setErrors] = useState<any>({
    buttons: buttons?.map(() => ({ number_value: "" })),
  });

  const addButton = () => {
    setButtons([...buttons, { number_value: "", text: "" }]);
    setErrors({
      ...errors,
      buttons: [...errors.buttons, { number_value: "" }],
    });
  };

  const removeButton = (index) => {
    const updatedButtons = buttons.filter((_, i) => i !== index);
    setButtons(updatedButtons);
    const updatedErrors = { ...errors };
    updatedErrors.buttons.splice(index, 1);
    setErrors(updatedErrors);
  };
  useEffect(() => {
    if (data && data?.style) {
      setStaticStyle({ label: data?.style, value: data?.style });
      setStyleType(data?.style);
    }
  }, [data]);
  const handleInputChange = (index, field, value) => {
    const updatedButtons = buttons.map((button, i) =>
      i === index ? { ...button, [field]: value } : button
    );
    setButtons(updatedButtons);
    const updatedErrors = { ...errors };
    if (updatedErrors.buttons[index]) {
      updatedErrors.buttons[index][field] = "";
    }
    setErrors(updatedErrors);
  };
  const handleStyleData = (keyName, keyValue) => {
    if (keyValue.value === "Select...") {
      setStyleType("");
    } else {
      setStyleType(keyValue.value);
    }
    setStaticStyle(keyValue);
  };

  const handleSave = async (pageId, id) => {
    const newErrors = {
      buttons: buttons?.map(() => ({ number_value: "" })),
    };

    buttons?.forEach((award, index) => {
      if (!award.number_value.trim()) {
        newErrors.buttons[index].number_value = "Number value is required.";
      }
      // if (!award.text?.trim()) {
      //   newErrors.buttons[index].text = "Text is required.";
      // }
    });

    setErrors(newErrors);

    if (newErrors?.buttons?.every((error) => !error.number_value)) {
      const payload = {
        segment_type: "number_scroll_segments",

        segment_header_text: headerText,
        style: styleType,
        scroll_numbers: buttons,

        background_image: (imageUrl === null || imageUrl == undefined) ? "" : imageUrl,
      background_image_id: (imageUrl === null || imageUrl == undefined) ? "" : imageId,
      mobile_background_image: (mobileBackground === null || mobileBackground == undefined) ? "" : mobileBackground,
      mobile_background_image_id: (mobileBackground === null || mobileBackground == undefined) ? "" : mobileBackgroundId,
      };

      try {
        setIsLoading(true);
        const response = await callApi(
          `v1/page/${pageId}/segment/${id}/update-info`,
          "post",
          payload
        );
        setIsLoading(false);
        if (response && response?.status === "Success") {
          setLoader(!loader);
          showNotification("Number Scroll added successfully!", "success");
        }
      } catch (e) {
        showNotification(
          "An error occurred while adding the banner. Please try again.",
          "error"
        );
        setIsLoading(false);
      }
    }
  };

  return (
    <>
      <div className="bg-white border border-black-600 rounded-[5px] px-8 py-4">
        <ToggleSwitch
          selectValue={data?.is_visible}
          versionValue={versionData?.is_visible}
          toggle={() =>
            toggleVisiblity(pageId, segmentId, segmentType, !data?.is_visible)
          }
          label="Is Segment Visible?"
          required={true}
        />
        <div className="mb-4 xl:col-span-12">
          <CustomInput
            label="Header Text"
            name="imageAlt"
            type="text"
            placeholder="Enter Banner Header Text"
            value={headerText}
            onChange={(e) => {
              setErrors((prev) => ({ ...prev, ["segment_header_text"]: "" }));
              setHeaderText(e.target.value);
            }}
            isVersioned={versionData?.segment_header_text ? true : false}
            versionedValue={versionData?.segment_header_text}
          />
        </div>

        <div>
          <div className="flex my-4">
            {imageUrl ? (
              <div className="flex items-center">
                <ImageData
                  imageLink={imageUrl}
                  setImageData={setImageData}
                  setImageLink={setImageUrl}
                />
                <div className="h-3 ml-3">
                  <button
                    onClick={() => {
                      toggleImage();
                      setIndexBack(undefined);
                      setImageData(undefined);
                    }}
                    className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                  >
                    Change
                  </button>
                </div>
              </div>
            ) : (
              <button
                onClick={() => {
                  toggleImage();
                  setIndexBack(undefined);
                  setImageData(undefined);
                }}
                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
              >
                Add BackgroundImage
              </button>
            )}
          </div>
          {/* {errors.image_url && (
            <p className="text-sm text-red-500">{errors.image_url}</p>
          )} */}
        </div>
        <div>
          <div className="flex my-4">
            {mobileBackground ? (
              <div className="flex items-center">
                <ImageData
                  imageLink={mobileBackground}
                  setImageData={setImageData}
                  setImageLink={setMobileBackground}
                />
                <div className="h-3 ml-3">
                  <button
                    onClick={() => {
                      toggleImage();
                      setIndexBack("background");
                      setImageData(undefined);
                    }}
                    className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                  >
                    Change
                  </button>
                </div>
              </div>
            ) : (
              <button
                onClick={() => {
                  toggleImage();
                  setIndexBack("background");
                  setImageData(undefined);
                }}
                className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
              >
                Add MobileBackground
              </button>
            )}
          </div>
        </div>
        <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
          <div className="mb-4 xl:col-span-6">
            <label className="inline-block mb-2 text-base font-medium">
              Style
            </label>
            <ReactSelect
              options={descriptionStyle}
              isSearchable={false}
              isMulti={false}
              placeholder={"Please select style type"}
              contentType={saticStyle}
              handleContentChange={handleStyleData}
              name={"style"}
              id={"style-type2"}
              versionData={{
                label: versionData?.style,
                value: versionData?.style,
              }}
            />
          </div>
        </div>

        {/* Add Button */}
        <div className="flex justify-end my-4">
          <button
            onClick={addButton}
            className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
          >
            Add Button
          </button>
        </div>

        {/* Render Buttons */}
        {versionData?.scroll_numbers?.length > 0 && <p>Old Data</p>}
        <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
          {versionData?.scroll_numbers?.length > 0 &&
            versionData?.scroll_numbers?.map((button, index) => (
              <div key={index} className="py-4 xl:col-span-4">
                <NumberScrollSegmentCard
                  key={index}
                  segmentId={segmentId}
                  pageId={pageId}
                  index={index}
                  buttonData={button}
                  handleInputChange={handleInputChange}
                  errors={errors}
                  removeButton={removeButton}
                  isEditable={false}
                  isLoading={isLoading}
                />
              </div>
            ))}
        </div>

        {buttons?.length > 0 && <p>New Data</p>}
        {/* Render Buttons */}
        <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
          {buttons?.map((button, index) => (
            <div className="py-4 xl:col-span-4">
              <NumberScrollSegmentCard
                key={index}
                index={index}
                segmentId={segmentId}
                pageId={pageId}
                buttonData={button}
                handleInputChange={handleInputChange}
                errors={errors}
                removeButton={removeButton}
                isEditable={true}
                isLoading={isLoading}
              />
            </div>
          ))}
        </div>
        {/* Save Button */}
        <div className="flex justify-end gap-2 mt-4">
          <Button
            isLoading={isLoading}
            handleSave={handleSave}
            pageId={pageId}
            id={segmentId}
          />

          <button
            className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
            onClick={() => handleDelete(segmentId, data?.segment_type)}
          >
            Delete
          </button>
        </div>
      </div>
      <Drawer
        show={showImage}
        onHide={toggleImage}
        id="drawerEnd"
        drawer-end="true"
        className="fixed inset-y-0 flex flex-col w-1/2 transition-transform duration-300 ease-in-out transform bg-white shadow ltr:right-0 rtl:left-0 z-drawer dark:bg-zink-600"
      >
        <Drawer.Header
          className="flex items-center justify-between p-4 border-b card-body border-slate-200 dark:border-zink-500"
          closeButtonClass="lucide lucide-x size-4 transition-all duration-200 ease-linear text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"
        >
          <Drawer.Title className="text-15">{"Select Image"}</Drawer.Title>
          <X className="transition-all duration-200 ease-linear size-4 text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"></X>
        </Drawer.Header>
        <Drawer.Body className="h-full p-4 overflow-y-auto">
          <ImageView
            showImage={showImage}
            setEventData={setImageData}
            togleImage={toggleImage}
          />
        </Drawer.Body>
      </Drawer>
    </>
  );
};

export default NumberScrollSegment;
